
import styled from 'styled-components';

const CartItemsWrapper = styled.div`
  h6 {
    color: var(--cartColors);
    font-size: 14px;
  }

  .div-control {
    left: -15%;
  }

  .image-container {
    margin: 0px 0px 0px 0px;
  }

  .total {
    font-weight: bold;
    font-size: 16px;
    color: var(--productTitle);
  }

  h5 {
    color: var(--titleWeek);
    font-size: 19.72px;
  }

  .svg-delivery {
    fill: white;
    background: var(--navbar-bg);
    padding: 5px;
    border-radius: 50%;
    width: 29px;
    height: 29px;
  }

  .bg-grey {
    background: var(--checkoutCard);
    padding: 3px;
    border-radius: 50%;
    width: 20px;
    height: 20px;
  }

  img {
    width: 100px;
    height: 92px;
    object-fit: cover;
  }

  span {
    color: var(--checkout-highlight-text);
    font-size: 14px;
  }

  small {
    color: var(--checkout-product-descr);
    font-size: 12.5px;
  }

  @media screen and (max-width: 540px) {
    .image-container {
      margin: 0;
    }

    small {
      font-size: 13.3px;
    }
  }
`;

export {CartItemsWrapper};